import React, { useEffect } from 'react';
import { logSessionInfo } from '../../../../../services/logger';
import './StudentUseIssueView.scss';

/**
 * StudentUseIssueView component displays tips for proper microphone usage.
 * Shown when the teacher identifies a student use issue with the recording.
 * 
 * @param {Object} props - Component props.
 * @param {Function} props.goBack - Callback to navigate back to ListenToRecordingView.
 * @param {Function} props.onExitTroubleshoot - Callback to exit troubleshooting and return to retry.
 */
export default function StudentUseIssueView(props) {
  const { goBack, onExitTroubleshoot } = props;

  const handleExitTroubleshoot = () => {
    logSessionInfo('teacherTroubleshoot_STUDENT_USE_ISSUE_EXIT_CLICKED', {});
    onExitTroubleshoot();
  };

  return (
    <div className="student-use-issue-view">
      <div className="student-use-issue-view__content">
        <div className="student-use-issue-view__instruction">
          <div className="student-use-issue-view__instruction-title">
            Check that the student is using the microphone correctly. They should:
          </div>
          <ul className="student-use-issue-view__instruction-list">
            <li>Speak in a clear, normal voice. Do not yell, even if there is background noise</li>
            <li>Place the microphone 6-12" from their mouth (or 2 inches if using headset)</li>
            <li>Face the microphone</li>
            <li>Respond when prompted</li>
          </ul>
        </div>
      </div>
      
      <div className="student-use-issue-view__button-container">
        <button 
          className="student-use-issue-view__button secondary"
          onClick={goBack}
        >
          Back
        </button>
        <button 
          className="student-use-issue-view__button"
          onClick={handleExitTroubleshoot}
        >
          Exit Troubleshoot
        </button>
      </div>
    </div>
  );
}
